"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TickIconSmall;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("../SvgIcon"));

/* eslint-disable max-len */
var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M13 0v13M0 0v13m5.146-3.439l-2.249-2.25a.5.5 0 0 1 0-.708l.706-.706a.5.5 0 0 1 .708 0L5.5 7.086l3.439-3.439a.5.5 0 0 1 .708 0l.706.706a.5.5 0 0 1 0 .708l-4.499 4.5a.502.502 0 0 1-.708 0",
  fillRule: "evenodd"
});

function TickIconSmall(props) {
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({}, props, {
    viewBox: "0 0 13 13"
  }), _ref);
}

TickIconSmall.displayName = 'TickIconSmall';